<template>
  <div class="mb-8 animate-fade-in">
    <nav v-if="breadcrumbs?.length" class="flex items-center gap-2 text-sm text-muted mb-4" aria-label="Breadcrumb">
      <template v-for="(crumb, index) in breadcrumbs" :key="index">
        <router-link
          v-if="crumb.to"
          :to="crumb.to"
          class="hover:text-foreground transition-colors"
        >
          {{ crumb.label }}
        </router-link>
        <span v-else>{{ crumb.label }}</span>
        <ChevronRight v-if="index < breadcrumbs.length - 1" class="h-4 w-4" aria-hidden="true" />
      </template>
    </nav>
    <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        <h1 class="text-h1">{{ title }}</h1>
        <p v-if="description" class="text-caption mt-2 max-w-2xl">{{ description }}</p>
      </div>
      <div v-if="$slots.actions" class="flex items-center gap-3 shrink-0">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronRight } from '@lucide/vue'

export default {
  name: 'PageHeader',
  components: { ChevronRight },
  props: {
    title: { type: String, required: true },
    description: String,
    breadcrumbs: Array,
  },
}
</script>
